module.exports = __webpack_public_path__ + "img/logo-trawling-2023-negra.42cabdc4.svg";